import { User, userDefault } from './User.js'
import { get } from 'svelte/store'
import { initialize as initializeFirebase, Authentication } from '@coldandgoji/svelte-firebase'
import { gravatar, log, publish } from '@coldandgoji/utilities'

let CONFIGURATION = null

const initializeUser = async () => {
  log( '@coldandgoji/svelte-authentication', 'initializeUser' )

  User.update( _User => {
    _User.initialized = true

    return _User
  } )

  publish( 'User.initialized', get( User ) )
}

const updateUser = async user => {
  log( '@coldandgoji/svelte-authentication', 'updateUser' )

  if ( user ) {
    // Determine user image
    const image = user.photoURL
      ? user.photoURL
      : await gravatar( user.email, { size: 200 } )

    // Get token if one not set
    const token = get( User ).token
      ? get( User ).token
      : await user.getIdToken( true )

    User.update( _User => {
      _User.anonymous = user.isAnonymous
      _User.authenticated = true
      _User.email = user.email
      _User.id = user.uid
      _User.image = image
      _User.name = user.displayName
      _User.reference = user
      _User.token = token
      _User.verified = user.emailVerified

      return _User
    } )
  } else {
    User.update( _User => {
      _User = userDefault()
      _User.initialized = true

      return _User
    } )
  }
}

const initialize = async configuration => {
  log( '@coldandgoji/svelte-authentication', 'initialize' )

  CONFIGURATION = configuration

  initializeFirebase( configuration )

  if ( !Authentication ) return true

  return new Promise( async ( resolve ) => {
    Authentication.onAuthStateChanged( async user => {
      log( '@coldandgoji/svelte-authentication', 'onAuthStateChanged', [
        `Initialized: ${ get( User ).initialized }`,
        `Anonymous: ${ get( User ).anonymous }`,
        `Authenticated: ${ get( User ).authenticated }`,
        `User: ${ !!user }`,
      ] )

      // Login
      // User is initialized, User is anonymous, user,
      // verified
      if ( get( User ).initialized && get( User ).anonymous && user && user.emailVerified ) {
        log( '@coldandgoji/svelte-authentication', 'onAuthStateChanged > User login' )
        await updateUser( user )
        publish( 'User.logged.in', get( User ) )
      }

      // Register
      // User is initialized, User is anonymous, user, not
      // verified
      if ( get( User ).initialized && get( User ).anonymous && user && !user.emailVerified ) {
        log( '@coldandgoji/svelte-authentication', 'onAuthStateChanged > User register' )
        await updateUser( user )
        publish( 'User.registered', get( User ) )
      }

      // Refresh authenticated
      // User is not initialized, User is anonymous, user
      if ( !get( User ).initialized && get( User ).anonymous && user ) {
        log( '@coldandgoji/svelte-authentication', 'onAuthStateChanged > Refresh authenticated' )
        publish( 'User.authenticated', get( User ) )
        await updateUser( user )
        await initializeUser()
      }

      // Refresh anonymous
      // User is not initialized, User is anonymous, !user
      if ( !get( User ).initialized && get( User ).anonymous && !user ) {
        log( '@coldandgoji/svelte-authentication', 'onAuthStateChanged > Refresh anonymous' )
        await initializeUser()
      }

      // User details changed
      // User is initialized, User is authenticated, user
      if ( get( User ).initialized && get( User ).authenticated && user ) {
        log( '@coldandgoji/svelte-authentication', 'onAuthStateChanged > Update user' )
        await updateUser( user )
        publish( 'User.updated', get( User ) )
      }

      // Logout
      // User is initialized, User is authenticated, !user
      if ( get( User ).initialized && get( User ).authenticated && !user ) {
        log( '@coldandgoji/svelte-authentication', 'onAuthStateChanged > User logout' )
        await updateUser( null )
        publish( 'User.logged.out', get( User ) )
      }

      resolve( true )
    } )
  } )
}

export {
  CONFIGURATION,
  initialize,
}
